import { defineMessages } from "react-intl";
export default defineMessages({
  connectionError: {
    "id": "network.connectionError",
    "defaultMessage": "Server not available"
  },
  networkError: {
    "id": "network.networkError",
    "defaultMessage": "Network not available"
  },
  timeoutError: {
    "id": "network.timeoutError",
    "defaultMessage": "Connection timeout"
  },
  serverError: {
    "id": "network.serverError",
    "defaultMessage": "Something went wrong..."
  },
  cancelError: {
    "id": "network.cancelError",
    "defaultMessage": "Request has been cancelled"
  },
  unknownError: {
    "id": "network.unknownError",
    "defaultMessage": "Unknown Error"
  }
});